var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#273943",
    fillRule: "evenodd",
    d: "M18 2.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Zm-2.796 4.749a3.75 3.75 0 1 0-.756-1.295L8.795 9.5a3.75 3.75 0 1 0 0 4.997l5.653 3.294a3.75 3.75 0 1 0 .758-1.294l-5.654-3.295a3.775 3.775 0 0 0 0-2.407l5.65-3.297Zm-7.287 3.323a.746.746 0 0 0 .054.091c.178.322.279.693.279 1.087a2.24 2.24 0 0 1-.333 1.178 2.25 2.25 0 1 1 0-2.357ZM15.75 19c0-.375.092-.729.254-1.04a.75.75 0 0 0 .112-.19A2.25 2.25 0 1 1 15.75 19Z",
    clipRule: "evenodd"
  })));
};
export default SvgShare;